import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { CabinetService } from '@cabinet/cabinet.service';
import * as fromRoot from '@core/redux';
import * as TaskActions from '@core/redux/task/task.actions';
import { Store } from '@ngrx/store';

import { BoardComponent } from '../board/board.component';
import { FilterControlsComponent } from '../filter-controls/filter-controls.component';
import { TaskViewComponent } from '../task-view/task-view.component';

@Component({
  selector: 'app-view-board',
  templateUrl: './view-board.component.html',
  standalone: true,
  imports: [CommonModule, NgClass, BoardComponent, FilterControlsComponent, TaskViewComponent],
  styleUrls: ['./view-board.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewBoardComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly store = inject<Store<fromRoot.State>>(Store);
  private readonly cabinetService = inject(CabinetService);
  private readonly destroyRef = inject(DestroyRef);

  readonly isOpenTask = signal<boolean>(false);

  constructor() {
    this.cabinetService.layout = 'board';
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this._toggleTask(params['id']);
    });
  }

  private _toggleTask(id: string | null) {
    this.store.dispatch(new TaskActions.OpenAction(id));
    this.isOpenTask.set(!!id);
  }
}
